import { createContext, useContext, useState, useEffect } from "react";

const ThemeContext = createContext(null);
export function getColors(isDark) {
  if (isDark) {
    return {
      bg:      "#050b14",
      panel:   "#080f1e",
      card:    "#0b1525",
      border:  "#0f2040",
      border2: "#162a4a",
      cyan:    "#00d4ff",
      teal:    "#00ffcc",
      amber:   "#ffb84d",
      pink:    "#ff4da6",
      purple:  "#a855f7",
      blue:    "#3b9eff",
      red:     "#ff3d5a",
      green:   "#00ff88",
      orange:  "#ff7c2a",
      lime:    "#b0ff4a",
      text:    "#e2eaf8",
      muted:   "#b8c7dc",
      muted2:  "#8fa4bf",
    };
  }
  return {
    bg:      "#f0f4fa",
    panel:   "#ffffff",
    card:    "#ffffff",
    border:  "#d0daea",
    border2: "#b8c8e0",
    cyan:    "#006ea8",
    teal:    "#007a65",
    amber:   "#b06000",
    pink:    "#b0006a",
    purple:  "#6d28d9",
    blue:    "#1a5fbb",
    red:     "#cc1133",
    green:   "#006633",
    orange:  "#cc4400",
    lime:    "#4a6a00",
    text:    "#0d1a2e",
    muted:   "#5a7090",
    muted2:  "#8090a8",
  };
}

export function getAuthColors(isDark) {
  if (isDark) {
    return {
      bg:               "#04080f",
      card:             "#090f1c",
      border:           "#111d2e",
      border2:          "#182640",
      cyan:             "#22d3ee",
      teal:             "#2dd4bf",
      purple:           "#a78bfa",
      red:              "#f43f5e",
      green:            "#10b981",
      text:             "#e8f0fd",
      sub:              "#94a3b8",
      muted:            "#3a5070",
      muted2:           "#1e3050",
      inputBg:          "#040a12",
      inputBorder:      "#111d2e",
      inputText:        "#e8f0fd",
      inputPlaceholder: "#1e3050",
      btnDisabledBg:    "#0e1a2a",
      btnDisabledColor: "#2a3f60",
    };
  }
  return {
    bg:               "#f0f4fa",
    card:             "#ffffff",
    border:           "#d0daea",
    border2:          "#b8c8e0",
    cyan:             "#006ea8",
    teal:             "#007a65",
    purple:           "#6d28d9",
    red:              "#cc1133",
    green:            "#006633",
    text:             "#0d1a2e",
    sub:              "#3a4a60",
    muted:            "#5a7090",
    muted2:           "#8090a8",
    inputBg:          "#f8fafd",
    inputBorder:      "#c0cce0",
    inputText:        "#0d1a2e",
    inputPlaceholder: "#8090a8",
    btnDisabledBg:    "#d8e0ec",
    btnDisabledColor: "#8090a8",
  };
}

export function ThemeProvider({ children }) {
  const [isDark, setIsDark] = useState(() => {
    try {
      const s = localStorage.getItem("plunger_theme");
      return s ? s === "dark" : true;
    } catch { return true; }
  });

  useEffect(() => {
    try { localStorage.setItem("plunger_theme", isDark ? "dark" : "light"); } catch {}
    document.body.style.background = isDark ? "#050b14" : "#f0f4fa";
    document.body.style.color      = isDark ? "#e2eaf8" : "#0d1a2e";
  }, [isDark]);

  return (
    <ThemeContext.Provider value={{ isDark, toggle: () => setIsDark(v => !v) }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() { return useContext(ThemeContext); }